/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import { Typography, Card } from '@mui/material';
import BackButton from '../BackButton';
import AdasImportant from "../../../../../../assets/images/ArticleImages/Why-ADAS-is-important.webp";
import WhyAdasImportant from "../../../../../../assets/images/ArticleImages/Why-ADAS-is-Important-in-Your-Vehicle-1-1536x861.webp";
import KeyAdasFeatures from "../../../../../../assets/images/ArticleImages/Key-ADAS-Features-in-Vehicles.webp";
import WhyAdasImportant2 from "../../../../../../assets/images/ArticleImages/Why-ADAS-is-Important-in-Your-Vehicle-2-1536x861.webp";
import WhyAdasImportant3 from "../../../../../../assets/images/ArticleImages/Why-ADAS-is-Important-in-Your-Vehicle-3-1536x878.webp";

// Define a type for the content blocks
type ContentBlock =
    | { type: 'heading'; value: string; variant?: 'h4' | 'h5' | 'h6' | 'subtitle2'; style?: React.CSSProperties }
    | { type: 'paragraph'; value: string; style?: React.CSSProperties }
    | { type: 'image'; src: string; alt?: string; style?: React.CSSProperties };

const AdasIsImportant: React.FC = () => {
    // Page header information
    const title = "Why ADAS is Important in Your Vehicle?";
    const headerImageSrc = AdasImportant;

    // Define the content of your article as a list of blocks.
    const contentBlocks: ContentBlock[] = [
        {
            type: 'paragraph',
            value: "In today’s rapidly advancing automotive industry, integrating Advanced Driver Assistance Systems (ADAS) in vehicles has become a crucial development. These systems represent a leap forward in vehicle safety, providing drivers with real-time assistance and information that can prevent accidents and save lives. As the technology behind ADAS continues to evolve, it is becoming an essential feature in modern vehicles, offering a range of benefits beyond safety. This blog will delve into why ADAS vehicles are the need of today’s scenario, exploring its features, benefits, and the technology driving it. By understanding the importance of ADAS, drivers can make informed decisions about their vehicle choices and prioritize their safety on the road.",
        },
        {
            type: 'image',
            src: WhyAdasImportant,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "Understanding ADAS in Vehicles",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "ADAS (Advanced Driver Assistance Systems) is a suite of electronic systems that assist drivers in driving and parking functions. By providing crucial information about the environment and surrounding conditions, ADAS enhances the safety and overall driving experience. These systems use various sensors, cameras, radar, and software to detect and respond to the surroundings.",
        },
        {
            type: 'heading',
            value: "Key ADAS Features in Vehicles:",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image',
            src: KeyAdasFeatures,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>1. Adaptive Cruise Control (ACC):</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Maintains a safe distance from the vehicle ahead by adjusting the speed.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>2. Lane Departure Warning (LDW):</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Informs the driver if the vehicle starts to veer out of its lane.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>3. Blind Spot Detection (BSD):</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Warns the driver of vehicles in the blind spot during lane changes.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>4. Automatic Emergency Braking (AEB):</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Automatically engages the brakes if a potential collision is detected.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>5. Traffic Sign Recognition (TSR):</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Detects and displays traffic signs on the vehicle’s dashboard.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>6. Driver Monitoring System (DMS):</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Ensures driver alertness by tracking eye movements and head position, providing alerts if drowsiness or inattention is detected.",
        },
        {
            type: 'heading',
            value: "The Importance of ADAS in Vehicles",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    1.<strong> Enhancing Safety:</strong> ADAS in vehicles significantly enhances road safety by reducing human error, which is a leading cause of accidents. Features like automatic emergency braking and lane departure warnings proactively prevent collisions and keep the vehicle in the correct lane, respectively. These systems are particularly beneficial in high-stress driving situations where driver fatigue or distraction can lead to accidents.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    2.<strong> Improving Driving Experience:</strong> ADAS technology provides a more comfortable and stress-free driving experience. Adaptive cruise control and parking assistance systems relieve the driver from constant monitoring and adjustments, allowing for a more relaxed journey, especially on long drives or in congested traffic.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    3.<strong> Reducing Traffic Accidents:</strong> Vehicle ADAS systems contribute to the overall reduction of traffic accidents. By automating responses to hazardous situations, such as sudden stops or lane changes, ADAS minimizes the risk of accidents. Studies have shown that vehicles equipped with ADAS technology have a lower accident rate compared to those without these systems.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    4.<strong> Lowering Insurance Costs:</strong> Insurance companies recognize the safety benefits of ADAS technology and often offer lower premiums for vehicles equipped with these systems. The reduced risk of accidents translates to fewer claims, incentivizing insurers to offer discounts to drivers who invest in ADAS-equipped vehicles.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    5.<strong> Meeting Regulatory Requirements:</strong> With the increasing emphasis on vehicle safety, regulatory bodies across the globe are mandating the inclusion of certain ADAS features in new vehicles. Compliance with these regulations not only ensures the safety of drivers and passengers but also keeps manufacturers ahead in the market.
                </>
            ) as unknown as string,
        },
        {
            type: 'image',
            src: WhyAdasImportant2,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "ADAS Technology in Cars",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    1.<strong> Sensor Integration:</strong> ADAS systems rely on a network of sensors, including radar, lidar, ultrasonic sensors, and cameras, to monitor the vehicle’s surroundings. These sensors provide real-time data, enabling the system to make quick and accurate decisions.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    2.<strong> Data Processing and Software:</strong> The information gathered by the sensors is processed by sophisticated software algorithms. These algorithms analyze the data to identify potential hazards and determine the appropriate response, such as alerting the driver or taking automated action.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    3.<strong> Connectivity:</strong> Modern ADAS systems are increasingly connected to other vehicles and infrastructure through Vehicle-to-Everything (V2X) communication. This connectivity enhances the system’s ability to predict and respond to dynamic road conditions, improving overall safety and efficiency.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    4.<strong> Artificial Intelligence (AI) and Machine Learning:</strong> AI and machine learning play a significant role in the development of ADAS technology. These technologies enable ADAS systems to learn from past experiences, improving their accuracy and reliability over time. For example, machine learning algorithms can enhance object detection and recognition capabilities, making ADAS systems more adept at identifying potential threats.
                </>
            ) as unknown as string,
        },
        {
            type: 'heading',
            value: "The Future of ADAS in Vehicles",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "As technology continues to evolve, the capabilities of ADAS in vehicles are expected to expand. Future advancements may include:",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    1.<strong> Fully Autonomous Driving:</strong> While current ADAS systems assist, the future points towards fully autonomous vehicles. ADAS technology will be a foundational component in achieving this goal, providing the necessary safety and reliability for driverless cars.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    2.<strong> Enhanced Connectivity:</strong> Improved V2X communication will allow ADAS-equipped vehicles to interact more seamlessly with other vehicles, pedestrians, and infrastructure. This connectivity will lead to more coordinated and efficient traffic management, reducing congestion and improving safety.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    3.<strong> Personalized Driving Experience:</strong> Advanced AI algorithms will enable ADAS systems to adapt to individual driving styles and preferences. This personalization will enhance the overall driving experience, making it more comfortable and intuitive for the driver.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    4.<strong> Greater Integration with Smart Cities:</strong> As cities become smarter, ADAS technology will integrate more closely with urban infrastructure. This integration will enable real-time traffic management, dynamic routing, and other smart city initiatives, further enhancing the safety and efficiency of urban transportation.
                </>
            ) as unknown as string,
        },
        {
            type: 'image',
            src: WhyAdasImportant3,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "Conclusion",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "The importance of ADAS in vehicles cannot be overstated. From enhancing safety and improving the driving experience to reducing accidents and meeting regulatory requirements, ADAS technology is transforming the automotive industry. As advancements continue, the role of ADAS will only grow, paving the way for a safer, more efficient, and more enjoyable driving experience.",
        },
        {
            type: 'paragraph',
            value: "Investing in a vehicle equipped with ADAS is not just about keeping up with technology; it’s about making a smart choice for your safety and the safety of others on the road. As we look to the future, ADAS will remain a critical component of modern vehicles, driving us toward a new era of automotive innovation and excellence. Explore the latest in ADAS vehicle systems at Novus HiTech and equip your vehicle with the best in advanced driver assistance technology.",
        },
    ];

    // Function to render each content block based on its type.
    const renderContentBlock = (block: ContentBlock, index: number) => {
        switch (block.type) {
            case 'heading':
                return (
                    <Typography
                        key={index}
                        variant={block.variant || 'h4'}
                        style={{ fontWeight: 600, ...block.style }}
                    >
                        {block.value}
                    </Typography>
                );
            case 'paragraph':
                return (
                    <Typography
                        key={index}
                        variant="body1"
                        style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            // color: 'gray',
                            ...block.style,
                        }}
                    >
                        {block.value}
                    </Typography>
                );
            case 'image':
                return (
                    <Card
                        key={index}
                        style={{
                            overflow: 'hidden',
                            borderRadius: 12,
                            ...block.style,
                        }}
                    >
                        <img
                            src={block.src}
                            alt={block.alt || 'Article image'}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </Card>
                );
            default:
                return null;
        }
    };

    return (
        <div className="flex flex-col w-full">
            <BackButton />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center' }}>
                {/* Header Section */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '766px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                    }}
                >
                    {/* Title & Tag Section */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Typography variant="h4" style={{ fontWeight: 600 }}>
                            {title}
                        </Typography>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '8px',
                            }}
                        >
                        </div>
                    </div>

                    {/* Header Image */}
                    <Card
                        style={{
                            width: '100%',
                            height: 384,
                            borderRadius: 12,
                            overflow: 'hidden',
                        }}
                    >
                        <img
                            src={headerImageSrc}
                            alt="Article header image"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </Card>
                </div>

                {/* Content Section */}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '766px',
                        padding: '16px 0',
                    }}
                >
                    {contentBlocks.map((block, index) => renderContentBlock(block, index))}
                </div>
            </div>
        </div>
    );
};

export default AdasIsImportant;


